import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import {
	NotificationListModel,
	NotificationStatsModel,
	BikSuggestModel,
	ALL_GROUP_NOTIFICATION,
} from 'Modules'
import { Id } from 'Src/types/aliases'

type NotificationList = {
	notifications: ResponseCatalog<NotificationListModel>
	requestParams: RequestParams
	message: NotificationListModel
	stats: NotificationStatsModel | null
	isVisibleDrawer: boolean
	group: string
	bik: BikSuggestModel[]
}

const initialState: NotificationList = {
	notifications: new ResponseCatalog<NotificationListModel>(),
	requestParams: new RequestParams(),
	message: new NotificationListModel(),
	stats: null,
	isVisibleDrawer: false,
	group: ALL_GROUP_NOTIFICATION,
	bik: [],
}

export namespace NotificationListNS {
	export type SetAll = PayloadAction<ResponseCatalog<NotificationListModel>>
	export type SetAllBik = PayloadAction<BikSuggestModel[]>
	export type SetStats = PayloadAction<NotificationStatsModel>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type SetMessage = PayloadAction<NotificationListModel>
	export type SetVisibleDrawer = PayloadAction<boolean>
	export type SetGroup = PayloadAction<string>
	export type GetAll = PayloadAction<{
		params: RequestParams
		clear: boolean
	}>
	export type DeleteOne = PayloadAction<Id>
	export type GetStats = PayloadAction
	export type ChangeGroup = PayloadAction<string>
	export type ReadOne = PayloadAction<Id>
	export type ReadAll = PayloadAction<string>
	export type DeleteAll = PayloadAction<string>
	export type ClickViewMessage = PayloadAction<string>
	export type GetAllBik = PayloadAction<{
		query: string
		clear: boolean
	}>
	export type GetMessage = PayloadAction<NotificationListModel>
}

export const notificationListSlice = createSlice({
	name: 'notificationList',
	initialState,
	reducers: {
		setAll: (state, action: NotificationListNS.SetAll) => {
			state.notifications = action.payload
		},
		setAllBik: (state, action: NotificationListNS.SetAllBik) => {
			state.bik = action.payload
		},
		setStats: (state, action: NotificationListNS.SetStats) => {
			state.stats = action.payload
		},
		setRequestParams: (state, action: NotificationListNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		setMessage: (state, action: NotificationListNS.SetMessage) => {
			state.message = action.payload
		},
		setVisibleDrawer: (state, action: NotificationListNS.SetVisibleDrawer) => {
			state.isVisibleDrawer = action.payload
		},
		setGroup: (state, action: NotificationListNS.SetGroup) => {
			state.group = action.payload
		},
		getAll: (state, action: NotificationListNS.GetAll) => {},
		deleteOne: (state, action: NotificationListNS.DeleteOne) => {},
		getStats: (state, action: NotificationListNS.GetStats) => {},
		changeGroup: (state, action: NotificationListNS.ChangeGroup) => {},
		readOne: (state, action: NotificationListNS.ReadOne) => {},
		readAll: (state, action: NotificationListNS.ReadAll) => {},
		deleteAll: (state, action: NotificationListNS.DeleteAll) => {},
		clickViewMessage: (state, action: NotificationListNS.ClickViewMessage) => {},
		getAllBik: (state, action: NotificationListNS.GetAllBik) => {},
		getMessage: (state, action: NotificationListNS.GetMessage) => {},
	},
})
